/**
 * created 24.08.2025
 */
import React from 'react';
import type {PropsWithChildren} from 'react';
import {useNavigate} from "react-router-dom";
import './CoursesCardsContainer.css';
import {useTranslation} from "react-i18next";

type CoursesCardsContainerComponentType = PropsWithChildren<{
  loading?: boolean;
  title: string;
  linkTitle?: string;
  linkHref: string;
  itemsCount: number;
}>

export function CoursesCardsContainer(props: CoursesCardsContainerComponentType) {
  const {t} = useTranslation();
  const {children, linkHref, linkTitle = t('product.courses.seeAll'), loading = false, title, itemsCount} = props;
  const navigate = useNavigate();

  if (!loading && itemsCount === 0) return null;

  const handleSeeAllClick = () => {
    navigate(linkHref);
  };

  return (
    <div className="recommended-section" aria-busy={loading || undefined}>
      <div className="recommended-header">
        {loading ? (
          // Header skeleton: long pill on the left, short pill on the right
          <>
            <div className="cc-skeleton cc-skel-title" aria-hidden="true" />
            <div className="cc-skeleton cc-skel-button" aria-hidden="true" />
          </>
        ) : (
          <>
            <h2 className="recommended-title">{title}</h2>
            <button className="see-all-button" onClick={handleSeeAllClick}>
              {linkTitle}
            </button>
          </>
        )}
      </div>

      {children}
    </div>
  );
}
